import { render, staticRenderFns } from "./EthicalManagement.vue?vue&type=template&id=f2315230&scoped=true"
import script from "./EthicalManagement.vue?vue&type=script&lang=js"
export * from "./EthicalManagement.vue?vue&type=script&lang=js"
import style0 from "./EthicalManagement.vue?vue&type=style&index=0&id=f2315230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2315230",
  null
  
)

export default component.exports